import { render, staticRenderFns } from "./PermissionsGuide.vue?vue&type=template&id=3b146bdb&scoped=true&"
import script from "./PermissionsGuide.vue?vue&type=script&lang=js&"
export * from "./PermissionsGuide.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsGuide.vue?vue&type=style&index=0&id=3b146bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b146bdb",
  null
  
)

export default component.exports